import React from 'react';
import Sym from './Sym';

/**
 * Tarjeta-KPI del rediseño: icono + valor (serif) + etiqueta + subtexto, con un
 * indicador secundario opcional arriba a la derecha.
 *
 * Sobre ese indicador: el diseño lo dibuja como un delta (+12%) contra el
 * periodo anterior, y ESO no se implementa porque el backend no expone
 * comparativos por KPI. El slot sí se usa cuando la pantalla ya calcula un dato
 * secundario real (p. ej. la tasa de descarga del panel de empresa), que antes
 * del rediseño también se mostraba.
 *
 * @param {string} icon   Material Symbol
 * @param {node}   value  valor ya formateado
 * @param {string} label  etiqueta
 * @param {string} sub    subtexto opcional
 * @param {string} tone   'brand' (default) | 'ok' | 'warn' | 'danger'
 * @param {node}   note      texto del indicador secundario
 * @param {string} noteIcon  Material Symbol del indicador
 * @param {'ok'|'warn'|'danger'|'muted'} noteTone
 */
const TONES = {
  brand:  { bg: 'var(--brand-soft)',  bd: 'var(--brand-line)',  fg: 'var(--brand-2)' },
  ok:     { bg: 'var(--ok-soft)',     bd: 'var(--ok)',          fg: 'var(--ok)' },
  warn:   { bg: 'var(--warn-soft)',   bd: 'var(--warn)',        fg: 'var(--warn)' },
  danger: { bg: 'var(--danger-soft)', bd: 'var(--danger)',      fg: 'var(--danger)' },
};

const NOTE_COLOR = {
  ok: 'var(--ok)', warn: 'var(--warn)', danger: 'var(--danger)', muted: 'var(--muted)',
};

const KpiCard = ({
  icon, value, label, sub, tone = 'brand',
  note, noteIcon, noteTone = 'muted',
  onClick, className = '',
}) => {
  const t = TONES[tone] || TONES.brand;
  const Tag = onClick ? 'button' : 'div';
  return (
    <Tag
      onClick={onClick}
      type={onClick ? 'button' : undefined}
      className={['a2-card', 'a2-card-hoverable', className].filter(Boolean).join(' ')}
      style={{
        padding: '18px 20px', textAlign: 'left', width: '100%',
        cursor: onClick ? 'pointer' : 'default', font: 'inherit',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10, marginBottom: 12 }}>
        {icon ? (
          <span className="a2-kpi-icon" style={{ background: t.bg, borderColor: t.bd, color: t.fg }}>
            <Sym name={icon} size={21} />
          </span>
        ) : <span />}
        {note ? (
          <span
            style={{
              display: 'inline-flex', alignItems: 'center', gap: 4, whiteSpace: 'nowrap',
              font: "600 .8rem 'Hanken Grotesk'", color: NOTE_COLOR[noteTone] || NOTE_COLOR.muted,
            }}
          >
            {noteIcon ? <Sym name={noteIcon} size={15} /> : null}
            {note}
          </span>
        ) : null}
      </div>
      <div className="a2-kpi-value">{value}</div>
      <div className="a2-kpi-label">{label}</div>
      {sub ? <div className="a2-kpi-sub">{sub}</div> : null}
    </Tag>
  );
};

export default KpiCard;
